import React from 'react'
import { prefixLink } from 'gatsby-helpers'
import Headroom from 'react-headroom'

import '../css/style'
import '../node_modules/flexboxgrid/dist/flexboxgrid'
import ReactGA from 'react-ga'
import { config } from 'config'
import { rhythm } from '../utils/typography'
import Menu from '../components/Menu'
import Footer from '../components/Footer'


class SiteTemplate extends React.Component {
	constructor(props) {
		super(props)
	}

  componentDidMount() {
    if (config.googleAnalyticsId) {
      ReactGA.initialize(`${config.googleAnalyticsId}`)
    }

		const fbConfig = {
			apiKey: "AIzaSyDeFmqbJBFUAxXWYPD2L0ZKOFzxNuwP9dw",
			authDomain: "acousticcleaning-com.firebaseapp.com",
			databaseURL: "https://acousticcleaning-com.firebaseio.com",
			storageBucket: "acousticcleaning-com.appspot.com"
		}
		firebase.initializeApp(fbConfig)
  }

  render () {
    const pages = [ ...this.props.route.pages ]
		const menuOrder = [
			'Home',
			'About',
			'Products',
			'Applications',
			'Parts & Service',
			'Learn'
		]

		pages.sort((a, b) => {
			const aIndex = menuOrder.indexOf(a.data.menuLabel)
			const bIndex = menuOrder.indexOf(b.data.menuLabel)
			if (aIndex < bIndex) {
				return -1
			} else if (aIndex > bIndex) {
				return 1
			}
			return 0
		})

    return (
      <div>
        <Headroom
          style={{
            backgroundColor: 'white',
            boxShadow: '0 0 5px 5px rgba(0,0,0,0.1)'
          }}
        >
          <div className="container">
            <div className="row center-xs start-sm">
              <div className="col-xs-12 col-sm-6">
                <a href={prefixLink('/')}>
                  <img className="logo" src="/images/acoustic-cleaning-systems-logo.png" alt={config.siteTitle} />
                </a>
              </div>
              <div className="col-xs-12 col-sm-6">
                <Menu
                  direction="horizontal"
                  pages={pages}
                  className="header-menu"
                  fileTypes={[ 'js' ]}
                />
              </div>
            </div>
          </div>
        </Headroom>

        {this.props.children}

        <Footer />
      </div>
    )
  }
}

SiteTemplate.propTypes = {
  children: React.PropTypes.any,
}

export default SiteTemplate



// WEBPACK FOOTER //
// ./_template.js